import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../../../../services/data.service';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { UserMatrixRowModel } from '../../../models/user-matrix-row-model';

@Component({
    selector: 'app-matrix-row-view',
    templateUrl: './matrix-row-view.component.html',
    styleUrls: ['./matrix-row-view.component.scss'],
    standalone: false
})
export class MatrixRowViewComponent {
    @Input() userMatrixRow: UserMatrixRowModel;
    tooltip_position = 'above';

    constructor(
        private dataSvc: DataService,
        private route: Router
    ) {}

    viewClick() {
        this.dataSvc.calculationData = JSON.parse(this.userMatrixRow.calculation);
        this.dataSvc.isMatrixData = true;

        switch (this.dataSvc.calculationData.type as unknown as CalculationType) {
            case CalculationType.StandardFlange:
            case CalculationType.OverriddenFlange:
                this.route.navigate(['/informate/standardflange', true]);
                break;
            case CalculationType.CustomFlange:
                this.route.navigate(['/informate/customflange', true]);
                break;
            case CalculationType.Clamp:
                this.route.navigate(['/informate/clamp', true]);
                break;
            case CalculationType.EngineeredJoint:
                this.route.navigate(['/informate/engineeredjoint', true]);
                break;
        }
    }
}
